import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import en from './locales/en.json';
import es from './locales/es.json';
import zhCN from './locales/zh-CN.json';
import zhHK from './locales/zh-HK.json';
import tl from './locales/tl.json';
import vi from './locales/vi.json';
import hi from './locales/hi.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  'zh-CN': { translation: zhCN },
  'zh-HK': { translation: zhHK },
  tl: { translation: tl },
  vi: { translation: vi },
  hi: { translation: hi },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

// Set initial language attribute on the HTML element
document.documentElement.lang = i18n.language || 'en';

// Update html lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;